import { TextField } from '@mui/material';

interface ApiEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function ApiEndpointField({
  value,
  error,
  setValue,
}: ApiEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      required
      label='API Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default ApiEndpointField;

